// Spec 078 — tipos de domínio da cena 3D. O que cruza o wire vem de @opus-dt/shared-types
// (z.infer do read model); o que é só UI (modo, qualidade, estado visual do material) vive aqui.
export type {
  LineSceneResponse,
  SceneFlow,
  SceneFlowQuality,
  SceneHeat,
  SceneMachine,
  SceneMeta,
  SceneModel,
  SceneNominal,
  ScenePlacement,
  SceneSegment,
  ScenePoint3,
} from "@opus-dt/shared-types";

/** view = tela da linha; edit = colocação (US4); ambient = TV (US5). */
export type SceneMode = "view" | "edit" | "ambient";

/** `low` desliga sombras e bloom (PerformanceMonitor do drei ou movimento reduzido). */
export type SceneQuality = "high" | "low";

/** Como o material corre num trecho, já resolvido a partir de status × vazão × reduced-motion. */
export interface FlowVisualState {
  /** múltiplo do ritmo base; 0 = congelado */
  speed: number;
  opacity: number;
  style: "solid" | "dashed" | "faded";
  /** fator de quantidade de grãos (movimento reduzido comunica vazão por densidade) */
  density: number;
}

/** Paleta lida dos tokens em runtime (theme-aware sem duplicar a paleta em JS). */
export interface ScenePalette {
  success: string;
  danger: string;
  warning: string;
  info: string;
  neutral: string;
  floor: string;
  grid: string;
  gridSection: string;
  fog: string;
  body: string;
  grain: string;
}

/** Pontos de entrada e saída do produto de uma máquina, já em coordenadas de mundo. */
export interface SceneAnchors {
  entry: { x: number; y: number; z: number };
  exit: { x: number; y: number; z: number };
  /** altura do topo (para o sinaleiro e o rótulo) */
  height: number;
}

// ── alternância 2D/3D (research R11) ────────────────────────────────────────────────────
export type LineView = "2d" | "3d";
export const SCENE_VIEW_QP_KEY = "view" as const;
export const LINE_VIEW_DEFAULT: LineView = "2d";

export function parseLineView(raw: string | null | undefined): LineView | null {
  return raw === "2d" || raw === "3d" ? raw : null;
}

export function lineViewStorageKey(userId: string, lineId: string): string {
  return `opus:line-view:${userId}:${lineId}`;
}

export const SCENE_STATUS_LABELS: Record<
  "RUNNING" | "STOPPED" | "IDLE" | "NODATA",
  { label: string; tone: "success" | "danger" | "warning" | "neutral" }
> = {
  RUNNING: { label: "Rodando", tone: "success" },
  STOPPED: { label: "Parada", tone: "danger" },
  IDLE: { label: "Ociosa", tone: "warning" },
  NODATA: { label: "Sem dados", tone: "neutral" },
};
